import React, { useEffect } from 'react';
import { Flex, IconChevronLeft, LoadingButton, TextButton } from '@zillow/constellation';
import { useWizard, useWizardStep } from '@zillow/zrs-rental-applications';
import { Steps } from '../DeclineApplicationPage.utils';

const StepNavigation = () => {
  const { onRequestPrev, onRequestNext, currentStep, isLoading } = useWizard();
  const { meta: { isStepDisabled = false, hideBackButton = false, hideStepNavigation = false } = {} } = useWizardStep({
    id: currentStep,
    subscription: ['isStepDisabled', 'hideBackButton', 'hideStepNavigation'],
  });

  useEffect(() => {
    // when step changes, scroll to top of screen
    window.scrollTo(0, 0);
  }, [currentStep]);

  if (hideStepNavigation) {
    return null;
  }

  return (
    <Flex aria-label="Navigation links" display="flex" justifyContent={hideBackButton ? 'flex-end' : 'space-between'}>
      {!hideBackButton && (
        <TextButton icon={<IconChevronLeft />} onClick={onRequestPrev} data-test="step_navigation__back">
          Back
        </TextButton>
      )}
      <LoadingButton
        onClick={onRequestNext}
        loading={isLoading}
        disabled={isStepDisabled}
        data-test="step_navigation__continue"
        buttonType="primary"
      >
        {currentStep === Steps.PreviewStep ? 'Send' : 'Continue'}
      </LoadingButton>
    </Flex>
  );
};

export default StepNavigation;
